import { z } from 'zod';

export const nativeAppVersionSchema = z.object({
  forceUpdate: z.boolean(),
  url: z.string(), // Eg https://apps.apple.com/au/app/orderhub-pos/id1620313307
  version: z.string(), // Eg '1.0.123'
});
